import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {DetailViewNotifyService} from '../../shared/detailview-notify.service';
import {DetailFormDataModel} from '../../../../config/model/detail-form-data.model';
import {MessageService} from '../../../../core/service/message.service';
import {DetailViewFormBuilderService} from 'src/app/shared/service/detail-view-form-builder.service';
import {TakeUntilDestroy} from "../../../../core/component/take-until-destroy";
import { takeUntil } from 'rxjs/operators';

// group-fields control
@Component({
    selector: 'group-fields',
    templateUrl: './group-fields.component.html',
    styleUrls: ['./group-fields.component.scss'],
    standalone: false
})
export class GroupFieldsComponent extends TakeUntilDestroy implements OnInit, OnDestroy {
  @Input() prop: any = {};
  @Input() graphicFormGroup: UntypedFormGroup;
  @Input() detailFormDataModel: DetailFormDataModel;

  private formField: UntypedFormControl;

  public formattedFormFields: any;

  constructor(
    private _detailViewNotifyService: DetailViewNotifyService,
    private _messageService: MessageService,
    private detailViewFormBuilderService: DetailViewFormBuilderService
  ) {
    super();
  }

  ngOnInit() {
    // create the form field
    this.formField = new UntypedFormControl(this.prop.field_name);
    // add new form field to form group
    this.graphicFormGroup.addControl(this.prop.field_name, this.formField);
    this.buildObjektInfoForm();
    // listen on validate event
   this._detailViewNotifyService.validateFeatureSubject.pipe(takeUntil(this.unsubscribe$)).subscribe(
      () => {
        this.validateField();
      }
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  /**
   * @name validateField
   * @description Validate fields on change and throw
   * proper error messages. This onChange Event-Listener method
   * will be called later than the binded Validator Object on the FormControl,
   * which makes it possible to check on the errors-array, because the error
   * values are already set.
   */
  validateField() {
    // if field validation has no errors
    if (!this.formField.errors) {
      return;
    }

    throw new Error('not implemented');
  }

  /**
   * builds the formGroup with the information from the maintable in the first tab
   */
  private buildObjektInfoForm() {
    // If formModel is not valid, do not show detail-view
    if (!this.detailFormDataModel) {
      this._messageService.error('NOTIFICATIONS.ERROR.OPEN_DETAILVIEW_INVALID');
    }
    const configFields = this.detailFormDataModel.configFormFields.filter(
      f => f.groupId === this.prop.field_group_id
    )[0];
    if (!configFields || !configFields.formFields) {
      return;
    }
    this.formattedFormFields = this.detailViewFormBuilderService.buildFormJson(
      this.detailFormDataModel.selectedFeatureFields,
      configFields.formFields
    );

    if (!this.formattedFormFields) {
      this._messageService.error('NOTIFICATIONS.ERROR.OPEN_DETAILVIEW_INVALID');
    }
  }

}
